var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpotify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.393 15.7511C13.616 14.0541 10.173 13.6591 6.15999 14.5771C5.80599 14.6581 5.58599 15.0101 5.66699 15.3631C5.74699 15.7161 6.09999 15.9371 6.45299 15.8561C10.12 15.0181 13.234 15.3601 15.709 16.8721C16.018 17.0611 16.422 16.9631 16.612 16.6541C16.801 16.3451 16.703 15.9401 16.393 15.7511Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.63 12.656C14.378 10.658 9.621 10.096 5.794 11.257C5.361 11.389 5.115 11.847 5.247 12.281C5.379 12.714 5.838 12.96 6.272 12.828C9.621 11.811 13.939 12.316 16.77 14.056C17.156 14.293 17.662 14.172 17.899 13.785C18.138 13.4 18.016 12.894 17.63 12.656Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.018 9.10305C15.108 6.78305 8.92101 6.56405 5.20001 7.69405C4.67901 7.85205 4.38502 8.40305 4.54302 8.92305C4.70002 9.44405 5.25101 9.73805 5.77201 9.57905C9.01401 8.59505 14.616 8.78005 18.012 10.7971C18.479 11.0751 19.084 10.9211 19.362 10.4521C19.639 9.98605 19.486 9.38105 19.018 9.10305Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/spotify.de403f547def1a792464f6084a87ae06.svg";
export { ForwardRef as ReactComponent };